import ErrorPage from "../ErrorPage/ErrorPage";
import React from "react";
import withTranslations from "../../../../../../../hocs/withTranslations";
import { compose } from "redux";
import { UrlProvider } from "../../../../../../../api/UrlProvider";

const PlansErrorPage = ({ translate, locale }) => {
  return (
    <ErrorPage
      title={translate("success-page_error-title")}
      description={translate("success-page_error-description")}
      refreshUrl={UrlProvider.getUrl("fe.plans.mainPage", { locale })}
    />
  );
};

export default compose(withTranslations)(PlansErrorPage);
